/**
 * 可复现伪随机数工具。
 *
 * 拼图要求"给定 seed → 切割结果完全一致"（可复现、可分享同一局），
 * 因此用确定性的 mulberry32，而非 Math.random()。
 */

/** mulberry32：32 位确定性 PRNG。返回一个产生 [0,1) 浮点的函数。 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** FNV-1a 变体：把任意字符串压成 32 位无符号种子（用于 imageHash / 命名种子）。 */
export function hashStringToSeed(input: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 13;
  h = Math.imul(h, 0x85ebca6b);
  h ^= h >>> 16;
  return h >>> 0;
}

/** 基于 rng 的常用分布助手。 */
export function makeRngHelpers(rng: () => number) {
  return {
    /** [min, max) 浮点。 */
    range: (min: number, max: number) => min + (max - min) * rng(),
    /** [min, max) 整数。 */
    int: (minInclusive: number, maxExclusive: number) =>
      Math.floor(minInclusive + (maxExclusive - minInclusive) * rng()),
    /** 数组随机取一。 */
    pick: <T>(arr: readonly T[]): T => arr[Math.floor(rng() * arr.length)],
  };
}
